import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import * as $ from 'jquery';
import {ServicesService} from '../../services.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css'],
    providers: [ServicesService]
})

export class NavbarComponent implements OnInit {
    
    userInfo: any;    
    
    constructor(private router: Router, private _services: ServicesService) {}

    ngOnInit() {
        var plataformaWeb = JSON.parse(localStorage.getItem("plataformaWeb"));
        this.userInfo = plataformaWeb.value.adinfo;
    }
    
    logOff() {
        var functions = this._services;
        var rota = this.router;
        functions.delLocalStorage("plataformaWeb");
        console.info("Piracanjuba Plataforma Web: Sessão Finalizada.");
        rota.navigate(['login']);
    }

}
